import web from "../web";

class HabilitationsService {
    index(token){
        return web.get("/api/habilitations", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/habilitations", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/habilitations/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/habilitations/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/habilitations/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new HabilitationsService()